import styled from '@emotion/styled';
import { rem } from 'polished';

import { ControlSC } from '~/utils/getControlStyle';

import down from '../../images/down.svg';
import control from '../../styles/control';
import spacing from '../../styles/spacing';

const SelectControl = styled(ControlSC)`
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;

  padding-right: ${spacing[10]};
  min-width: -webkit-fill-available;

  background-image: url(${down});
  background-repeat: no-repeat, repeat;
  background-position: right ${control.padding.x.base} top 50%, 0 0;
  background-size: ${rem(12)} auto, 100%;
  option {
    font-weight: normal;
  }

  .has-attributes &,
  .has-button & {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

const Select = SelectControl.withComponent('select');

export default Select;
